__turbopack_context__.v({
  "formBody": "auth-shell-module__3vXZna__formBody",
  "formColumn": "auth-shell-module__3vXZna__formColumn",
  "formFooter": "auth-shell-module__3vXZna__formFooter",
  "formHeader": "auth-shell-module__3vXZna__formHeader",
  "layout": "auth-shell-module__3vXZna__layout",
  "pressable": "auth-shell-module__3vXZna__pressable",
  "quoteBlock": "auth-shell-module__3vXZna__quoteBlock",
  "terraceColumn": "auth-shell-module__3vXZna__terraceColumn",
  "terraceImage": "auth-shell-module__3vXZna__terraceImage",
  "terraceVignette": "auth-shell-module__3vXZna__terraceVignette",
});
